let initialized = false;

function pageView(url) {
  const id = document.querySelector('meta[name="google-analytics-id"]')?.content;
  if (!id) return;

  if (!initialized) {
    initialized = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());

    // Queue page views immediately, but download analytics after visible assets.
    const load = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
      document.head.appendChild(script);
    };
    const afterLoad = () => {
      if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 2000 });
      else window.setTimeout(load, 200);
    };
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
  }

  window.gtag('config', id, { page_location: url });
}

document.addEventListener('turbo:load', event => pageView(event.detail.url));

// The quote studio uses a deferred pack without Turbo.
if (document.querySelector('meta[name="google-analytics-id"][data-standalone]')) {
  pageView(window.location.origin + window.location.pathname);
}
